import * as React from "react";

const ModalCloseHover: React.FC = () => (
    <svg
        width="15px"
        height="15px"
        viewBox="0 0 15 15"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <polygon
            fill="currentColor"
            points="7.5 6.407 1.093 0 0 1.093 6.407 7.5 0 13.907 1.093 15 7.5 8.593 13.907 15 15 13.907 8.593 7.5 15 1.093 13.907 0"
        />
    </svg>
);

export default React.memo(ModalCloseHover);
